export default {"src":"/_next/static/media/map.mono.f42ecd36.svg","height":364,"width":363,"blurWidth":0,"blurHeight":0};